import type { ApiResponse, PlannerTask, PlannerTaskRelation } from '@vision/ui/interfaces';
import type { PlannerTaskRelationResponseDto } from './task-relations.api.types';
import type { PlannerTaskResponseDto } from './tasks.api.types';

export function fromApiTaskRelation({
  object,
  task,
  ...relation
}: PlannerTaskRelationResponseDto): PlannerTaskRelation {
  return {
    ...relation,
    record: relation.record ?? (typeof object === 'object' ? object : undefined),
    task: task ? fromApiTask(task) : undefined,
  };
}

function fromApiTask(task: PlannerTaskResponseDto): PlannerTask {
  return { ...task, task_relations: (task.task_relations ?? []).map(fromApiTaskRelation) };
}

export function fromApiPlannerTaskResponse(response: ApiResponse<PlannerTaskResponseDto>): ApiResponse<PlannerTask> {
  return { ...response, data: fromApiTask(response.data) };
}

export function fromApiPlannerTasksResponse(
  response: ApiResponse<PlannerTaskResponseDto[]>,
): ApiResponse<PlannerTask[]> {
  return { ...response, data: response.data.map(fromApiTask) };
}
